import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { OktaService } from '@app/core/services/okta.service';

export const isAuthenticated: CanActivateFn = () => {
  const oktaService = inject(OktaService);
  const router = inject(Router);
  const isLogged = oktaService.hasValidAccessToken();
  if (!isLogged) router.navigateByUrl('/login');
  return isLogged;
};

export const isAnonymous: CanActivateFn = () => {
  const oktaService = inject(OktaService);
  const router = inject(Router);
  const isLogged = oktaService.hasValidAccessToken();
  if (isLogged) router.navigateByUrl('/');
  return !isLogged;
};
